export const ERA_EOB_STATUS = { OPEN: 'Open', CLOSED: 'Closed' };

export const getEraEobStatuses = ({ currentStatus }) => {
  const statuses = Object.values({
    WORKING: 'Working',
    ...ERA_EOB_STATUS,
  });

  return currentStatus === 'Working' ? statuses.reverse() : statuses;
};

export const ERA_CLAIM_STATUSES = Object.freeze({
  1: 'Processed as Primary',
  2: 'Processed as Secondary',
  3: 'Processed as Tertiary',
  4: 'Denied',
  19: 'Processed as Primary, Forwarded to Additional Payer(s)',
  20: 'Processed as Secondary, Forwarded to Additional Payer(s)',
  21: 'Processed as Tertiary, Forwarded to Additional Payer(s)',
  22: 'Reversal of Previous Payment',
  23: 'Not Our Claim, Forwarded to Additional Payer(s)',
  25: 'Predetermination Pricing Only - No Payment',
});

export const PROCESSED_AS_PRIMARY = ERA_CLAIM_STATUSES[1];
export const DENIED = ERA_CLAIM_STATUSES[4];
export const REVERSAL_OF_PREVIOUS_PAYMENT = ERA_CLAIM_STATUSES[22];

export const ERA_WARNINGS = {
  CLAIM_LEVEL: [
    {
      id: 'CLAIM_SPARE_ADJ',
      label: 'Claim has an adjustment that is not associated to a line item',
    },
    { id: 'CLAIM_REVERSAL', label: 'Claim is a reversal.' },
    {
      id: 'CLAIM_REVERSAL_ZERO_DOLLAR',
      label: 'Includes $0 issued, resulting in no money to reverse.',
    },
    { id: 'CLAIM_DENIED', label: 'Claim is denied.' },
    {
      id: 'CLAIM_UNMATCHED',
      label: 'Patient control number does not match to a claim in the system.',
    },
  ],
  LINE_ITEM_LEVEL: [
    {
      id: 'CHARGE_ALREADY_ALLOCATED',
      label: 'Claim charge has been allocated to previously in this file',
    },
    {
      id: 'CHARGE_INSUFFICIENT_BALANCE',
      label: 'Insufficient remaining payment balance to fully allocate charge.',
    },
    {
      id: 'CHARGE_WRITTEN_OFF',
      label: 'This line item is being fully written off.',
    },
    { id: 'CHARGE_OUT_OF_BALANCE', label: 'Line item is out of balance.' },
    {
      id: 'CHARGE_PAYMENT_RECEIVED',
      label: 'Line item primary payment already received',
    },
    {
      id: 'CHARGE_NEGATIVE_ADJ',
      label: 'Line item has negative patient adjustments',
    },
    {
      id: 'CHARGE_UNMATCHED',
      label: 'Matching charge cannot be found in system',
    },
    {
      id: 'CHARGE_MULTIPLE_MATCH',
      label:
        'Multiple possible matches identified, please use the “Match Charge” action to manually select the correct charge.',
    },
    {
      id: 'CHARGE_NO_SEC_PAT_RESP',
      label:
        'Unable to post because charge has no secondary or patient responsibility',
    },
    { id: 'CHARGE_SPLIT', label: 'Possible split line item detected.' },
    {
      id: 'CHARGE_OUT_OF_BALANCE_SYSTEM',
      label: 'System charge is out of balance',
    },
    {
      id: 'CHARGE_NO_SECONDARY',
      label: 'Line item does not have secondary insurance.',
    },
    {
      id: 'CHARGE_RESP_NOT_VALID',
      label: 'Patient responsibility is not valid.',
    },
  ],
};
